//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Layout from '@/components/ResponsiveLayout'
import SwoopForm from '@/components/SwoopForm'
import Header from './header'
import gql from 'graphql-tag'

export default {
  components: {
    Layout,
    Header,
    SwoopForm
  },

  data() {
    return {
      form: null, // SwoopForm api object
      fields: [],
      me: {},
      account: {}
    }
  },

  apollo: {
    me: {
      query: gql`
        query Query {
          me {
            id
            account {
              id
              name
              phone
              fax
              unit_number
              street_number
              street
              city
              post_code
              state
              postal_same_as_main
              postal_unit_number
              postal_street_number
              postal_street
              postal_city
              postal_post_code
              postal_state
              accounts_email
              support_email
              sales_email
              provisioning_email
            }
          }
        }
      `
    }
  },

  watch: {
    me: function() {
      this.$set(this, 'account', this.me.account)
    },
    'account.postal_same_as_main': function() {
      if (this.account.postal_same_as_main) {
        this.$set(this.account, 'postal_unit_number', this.account.unit_number)
        this.$set(
          this.account,
          'postal_street_number',
          this.account.street_number
        )
        this.$set(this.account, 'postal_street', this.account.street)
        this.$set(this.account, 'postal_city', this.account.city)
        this.$set(this.account, 'postal_post_code', this.account.post_code)
        this.$set(this.account, 'postal_state', this.account.state)
        this.form.load(this.account)
      }
    }
  },

  methods: {
    reset() {
      this.form.reset()
      this.getFields()
    },

    async updateAccount() {
      if (this.form.focusError()) {
        return
      }

      let updateData = {
        id: this.account.id,
        name: this.account.name,
        phone: this.account.phone,
        fax: this.account.fax,
        unit_number: this.account.unit_number,
        street_number: this.account.street_number,
        street: this.account.street,
        city: this.account.city,
        post_code: this.account.post_code,
        state: this.account.state,
        postal_same_as_main: this.account.postal_same_as_main,
        postal_unit_number: this.account.postal_unit_number,
        postal_street_number: this.account.postal_street_number,
        postal_street: this.account.postal_street,
        postal_city: this.account.postal_city,
        postal_post_code: this.account.postal_post_code,
        postal_state: this.account.postal_state,
        accounts_email: this.account.accounts_email,
        support_email: this.account.support_email,
        sales_email: this.account.sales_email,
        provisioning_email: this.account.provisioning_email
      }

      await this.$apollo
        .mutate({
          mutation: gql`
            mutation($input: AccountInput!) {
              updateAccount(input: $input) {
                id
                name
                phone
                fax
                unit_number
                street_number
                street
                city
                post_code
                state
                postal_same_as_main
                postal_unit_number
                postal_street_number
                postal_street
                postal_city
                postal_post_code
                postal_state
                accounts_email
                support_email
                sales_email
                provisioning_email
              }
            }
          `,
          variables: {
            input: updateData
          }
        })
        .then(data => {})
        .catch(() => {})
    },

    getFields() {
      let fields = [
        { heading: 'Details', size: 'small' },
        {
          id: 'name',
          label: 'Account Name',
          readonly: true
        },
        {
          id: 'phone',
          label: 'Account Phone Number',
          type: 'phone',
          required: true
        },
        {
          id: 'fax',
          label: 'Account Fax Number',
          type: 'phone'
        },
        { heading: 'Account Main Address', size: 'small' },
        {
          id: 'unit_number',
          label: 'Unit #'
        },
        {
          id: 'street_number',
          label: 'Street #'
        },
        {
          id: 'street',
          label: 'Street Name',
          case: 'title'
        },
        {
          id: 'city',
          label: 'City',
          case: 'title'
        },
        {
          id: 'post_code',
          label: 'Postcode'
        },
        {
          id: 'state',
          label: 'State',
          type: 'list',
          options: [
            { label: 'New South Wales', value: 'NSW' },
            { label: 'Queensland', value: 'QLD' },
            { label: 'Victoria', value: 'VIC' },
            { label: 'South Australia', value: 'SA' },
            { label: 'Western Australia', value: 'WA' },
            { label: 'Australian Capital Territory', value: 'ACT' },
            { label: 'Northern Territory', value: 'NT' },
            { label: 'Tasmania', value: 'TAS' }
          ]
        },
        { heading: 'Postal Address', size: 'small' },
        {
          id: 'postal_same_as_main',
          label: 'Copy from main address',
          type: 'checkbox',
          colspan: 3
        },
        {
          id: 'postal_unit_number',
          label: 'Unit #',
          disabled(data) {
            return data.postal_same_as_main
          }
        },
        {
          id: 'postal_street_number',
          label: 'Street #',
          disabled(data) {
            return data.postal_same_as_main
          }
        },
        {
          id: 'postal_street',
          label: 'Street Name',
          case: 'title',
          disabled(data) {
            return data.postal_same_as_main
          }
        },
        {
          id: 'postal_city',
          label: 'City',
          case: 'title',
          disabled(data) {
            return data.postal_same_as_main
          }
        },
        {
          id: 'postal_post_code',
          label: 'Postcode',
          disabled(data) {
            return data.postal_same_as_main
          }
        },
        {
          id: 'postal_state',
          label: 'State',
          type: 'list',
          options: [
            { label: 'New South Wales', value: 'NSW' },
            { label: 'Queensland', value: 'QLD' },
            { label: 'Victoria', value: 'VIC' },
            { label: 'South Australia', value: 'SA' },
            { label: 'Western Australia', value: 'WA' },
            { label: 'Australian Capital Territory', value: 'ACT' },
            { label: 'Northern Territory', value: 'NT' },
            { label: 'Tasmania', value: 'TAS' }
          ],
          disabled(data) {
            return data.postal_same_as_main
          }
        },
        { heading: 'Account E-Mail Addresses', size: 'small' },
        {
          id: 'accounts_email',
          label: 'Account Email Address',
          type: 'email'
        },
        {
          id: 'support_email',
          label: 'Support Email Address',
          type: 'email'
        },
        {
          id: 'sales_email',
          label: 'Sales Email Address',
          type: 'email'
        },
        {
          id: 'provisioning_email',
          label: 'Provisioning Email Address',
          type: 'email'
        }
      ]
      this.fields = fields
    }
  },

  created() {
    this.getFields()
  }
}
